import React, { useState, useEffect } from 'react';
import { ROLES } from '../utils/roles';
import './EditCensorModal.css';

const EditCensorModal = ({ censor, onClose, onSave, onDelete, user }) => {
  const [formData, setFormData] = useState({
    fornavn: '', efternavn: '', email: '', telefon: '',
    arbejds_status: 'Tilgængelig',
    sprogcenter_id: '',
    adresse: '', postnummer: '', forstad: ''
  });

  const [exams, setExams] = useState({ PD1: false, PD2: false, PD3: false, SP: false, VP: false });
  // State til at huske hvad der var sat fra start (til låsning)
  const [initialExams, setInitialExams] = useState({});

  // Når modalen åbner (eller censor ændres), fyld formularen ud
  useEffect(() => {
    if (censor) {
      setFormData({
        fornavn: censor.fornavn || '',
        efternavn: censor.efternavn || '',
        email: censor.email || '',
        telefon: censor.telefon || '',
        arbejds_status: censor.arbejds_status || 'Tilgængelig',
        sprogcenter_id: censor.sprogcenter_id,
        adresse: censor.adresse || '',
        postnummer: censor.postnummer || '',
        forstad: censor.forstad || ''
      });

      // Indlæs eksisterende checkbox værdier fra databasen
      const loadedExams = {
        PD1: censor.beskikket_pd1 || false,
        PD2: censor.beskikket_pd2 || false,
        PD3: censor.beskikket_pd3 || false,
        SP: censor.beskikket_sp || false,
        VP: censor.beskikket_indfodsret || censor.beskikket_medborgerskab || false
      };
      setExams(loadedExams);
      setInitialExams(loadedExams); // Gem kopi for at kunne låse dem der allerede er sande
    }
  }, [censor]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleCheck = (key) => {
    // Ekstra sikkerhed: Stop hvis man forsøger at ændre en låst værdi
    const isLocked = user.role === ROLES.SC_ADMIN && initialExams[key] === true;
    if (isLocked) return;

    setExams(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const finalData = {
      ...formData,
      id: censor.id,
      beskikket_pd1: exams.PD1,
      beskikket_pd2: exams.PD2,
      beskikket_pd3: exams.PD3,
      beskikket_sp: exams.SP,
      beskikket_vp: exams.VP
    };
    onSave(finalData);
  };

  const handleDeleteClick = () => {
    // Man må ikke slette hvis der er beskikkelser og man er SC_ADMIN
    const hasAny = Object.values(initialExams).some(val => val === true);
    if (user.role === ROLES.SC_ADMIN && hasAny) {
        alert('Du kan ikke slette en person, der allerede er beskikket som censor.');
        return;
    }
    if (window.confirm(`Slet ${formData.fornavn}?`)) onDelete(censor.id);
  };

  if (!censor) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>

        <div className="modal-header">
          <h2 className="modal-title">Rediger underviser/censor</h2>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-form-grid">
            <div className="form-group"><label>Fornavn</label><input name="fornavn" value={formData.fornavn} onChange={handleChange} required /></div>
            <div className="form-group"><label>Efternavn</label><input name="efternavn" value={formData.efternavn} onChange={handleChange} required /></div>
            <div className="form-group"><label>Email</label><input type="email" name="email" value={formData.email} onChange={handleChange} required /></div>
            <div className="form-group"><label>Telefon</label><input name="telefon" value={formData.telefon} onChange={handleChange} /></div>

            <div className="form-group full-width" style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: '10px' }}>
              <div>
                <label>Adresse</label>
                <input name="adresse" value={formData.adresse} onChange={handleChange} placeholder="Gadevej 1" />
              </div>
              <div>
                <label>Postnr</label>
                <input name="postnummer" value={formData.postnummer} onChange={handleChange} placeholder="1234" />
              </div>
              <div>
                <label>By</label>
                <input name="forstad" value={formData.forstad} onChange={handleChange} placeholder="By" />
              </div>
            </div>

            <div className="form-group full-width" style={{marginTop: '-10px'}}>
              <label>Arbejds Status</label>
              <select name="arbejds_status" value={formData.arbejds_status} onChange={handleChange} style={{ width: '100%', padding: '10px' }}>
                <option value="Tilgængelig">Tilgængelig</option>
                <option value="Pause">Pause</option>
                <option value="Sygemeldt">Sygemeldt</option>
                <option value="Orlov">Orlov</option>
                <option value="Barsel">Barsel</option>
                <option value="Ferie">Ferie</option>
                <option value="Inaktiv">Inaktiv</option>
              </select>
            </div>

            <div className="form-group full-width" style={{marginTop: '-10px'}}>
            <label style={{display:'block', marginBottom:'10px', fontWeight:'600', color:'#555'}}>Beskikkelser</label>
              <div style={{display: 'flex', gap: '15px', flexWrap: 'wrap'}}>
                {['PD1', 'PD2', 'PD3', 'SP', 'VP'].map(type => {
                  // Beregn om den er låst for denne bruger
                  const isLocked = user.role === ROLES.SC_ADMIN && initialExams[type] === true;
                  
                  return (
                    <label key={type} style={{
                        display:'flex', alignItems:'center', gap:'8px', 
                        cursor: isLocked ? 'not-allowed' : 'pointer', 
                        userSelect:'none',
                        opacity: isLocked ? 0.6 : 1, // Greyed out effekt
                        fontWeight: '500'
                    }} title={isLocked ? "Kan ikke fjernes af administrator" : ""}>
                        <input 
                        type="checkbox" 
                        checked={exams[type]} 
                        onChange={() => handleCheck(type)}
                        disabled={isLocked} // Native HTML disable
                        style={{width:'18px', height:'18px', accentColor: '#003366'}}
                        />
                        {type}
                    </label>
                    );
                })}
                </div>
                {user.role === ROLES.SC_ADMIN && (
                    <small style={{display:'block', marginTop:'10px', color:'#666', fontSize:'0.75rem', fontStyle:'italic'}}>
                        Beskikkelser tildeles af SIRI. Du kan tilføje nye kompetencer, men ikke fjerne eksisterende.
                    </small>
                )}
            </div>

          </div>

          <div className="modal-footer">
            <button type="button" className="btn-delete" onClick={handleDeleteClick} disabled={false}>Slet Person</button>
            <div className="modal-actions" style={{marginTop: 0}}>
              <button type="button" className="btn-cancel" onClick={onClose}>Annuller</button>
              <button type="submit" className="btn-save">Gem Ændringer</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditCensorModal;